import { useDispatch } from 'react-redux';
import { FlexContainer, Text, Icon, Buttons } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { showModalAction } from 'Store/modules/app/actions';
import { useTranslation } from 'Hooks/useTranslation';
import { FilingComponentsProps } from 'Containers/Filing/types';
import Trans from 'Components/Trans';
import { Money } from 'Components/icons/Money';
import FormEfirma from 'Components/FormEfirma';
import { setBodyOverflow } from 'Styles/utils/utils';
import { EFIRMA_MODAL } from 'Constants/modals';
import * as Styled from './styles';

const InstantRefundEfirma = ({ onChangeStep }: FilingComponentsProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.FILING);
  const dispatch = useDispatch();

  const openModalEfirma = (): void => {
    setBodyOverflow();
    dispatch(
      showModalAction({
        options: {
          type: EFIRMA_MODAL,
          data: { onChangeStep, isInstantRefund: true },
        },
        Component: FormEfirma,
      })
    );
  };

  return (
    <Styled.Container>
      <FlexContainer direction="column" justify="center" align="center" gap="dimension_16">
        <Text type="headline" size="S_L_S" color="dark" align="center">
          {t(`InstantRefund.finish.title`)}
        </Text>
        <Text size="S_S_S" color="dark" type="paragraphs" align="center">
          {t('InstantRefund.finish.info')}
        </Text>
        <Styled.InfoContainer direction="column" gap="dimension_16" justify="center" align="center">
          <Money />
          <Styled.TextContainer gap="dimension_08">
            <Icon icon="IconInfoSolidMDark" color="active" height={24} width={24} />
            <Text size="S_S_S" color="fresh" type="paragraphs">
              <Trans
                i18nKey={t('InstantRefund.info')}
                components={{
                  span: <span />,
                }}
                ns="filing"
              />
            </Text>
          </Styled.TextContainer>
          <Buttons.Classic
            mode="success"
            label={t('InstantRefund.efirma')}
            size="s"
            onClick={openModalEfirma}
          />
          <Buttons.Tiny
            mode="success"
            label={t('InstantRefund.not.efirma')}
            onClick={() => onChangeStep(7)}
          />
        </Styled.InfoContainer>
      </FlexContainer>
    </Styled.Container>
  );
};

export default InstantRefundEfirma;
